import { useEffect, useMemo, useState } from "react";
import awsConfig from "../aws-config";
import { STARTER_PLAN, LIFETIME_PLANS, getPlanById } from "../constants/upgradePlans";
import { resolveSaleWindow, formatCountdown } from "../utils/ltdSale";
import { useCountdown } from "./useCountdown";

export function useLifetimeUpgradePlans() {
  const saleWindow = useMemo(
    () => resolveSaleWindow(awsConfig.ltd_sale_start, awsConfig.ltd_sale_end),
    []
  );

  const countdownTarget =
    saleWindow.phase === "active"
      ? saleWindow.end
      : saleWindow.phase === "upcoming"
      ? saleWindow.start
      : null;
  const remainingMs = useCountdown(countdownTarget);
  const countdownLabel =
    saleWindow.phase === "active" || saleWindow.phase === "upcoming"
      ? formatCountdown(remainingMs)
      : null;

  const availablePlans = useMemo(
    () => (saleWindow.phase === "active" ? [...LIFETIME_PLANS, STARTER_PLAN] : [STARTER_PLAN]),
    [saleWindow.phase]
  );

  const defaultPlanId = availablePlans[0]?.id || STARTER_PLAN.id;
  const [selectedPlanId, setSelectedPlanId] = useState(defaultPlanId);

  useEffect(() => {
    setSelectedPlanId((current) => {
      const isValid = availablePlans.some((plan) => plan.id === current);
      if (isValid) {
        return current;
      }
      return defaultPlanId;
    });
  }, [availablePlans, defaultPlanId]);

  const selectedPlan = useMemo(() => getPlanById(selectedPlanId), [selectedPlanId]);

  return {
    saleWindow,
    countdownLabel,
    availablePlans,
    selectedPlanId,
    setSelectedPlanId,
    selectedPlan,
  };
}
